<template>
  <div class="index" ref="index">
    <Layout style="height: 100%">
      <Header>
        <Menu mode="horizontal" theme="dark" active-name="1">
          <div class="layout-logo">
            <img src="../assets/index-logo.png" alt="" style="width: 100%">
          </div>
          <div class="layout-nav">
            <Button type="primary" @click="logOut">退出</Button>
          </div>
        </Menu>
      </Header>
      <Layout style="height: 80%">
        <Sider hide-trigger :style="{background: '#fff', height: '100%'}">
          <!-- <Menu theme="light" width="auto">
            <Submenu name="1">
              <template slot="title">
                <Icon type="md-settings"></Icon>
                Setting
              </template>
              <MenuItem name="1-1" @click.native="$router.push('/setting/system')">System</MenuItem>
            </Submenu>
          </Menu> -->
           <Menu active-name="1" width="auto">
             <MenuGroup title="">
              <MenuItem name="1"  @click.native="$router.push('/deviceDeliveryQuery')" >
                <Icon type="md-cube" />
                出货查询
              </MenuItem>
              <MenuItem name="2" @click.native="$router.push('/deviceReceiveQuery')">
                <Icon type="md-cart" />
                收货查询
              </MenuItem>
              <MenuItem name="3" @click.native="$router.push('/addDeviceModel')">
                <Icon type="md-add" />
                添加机器
              </MenuItem>
            </MenuGroup>
          </Menu>
        </Sider>
        <Layout :style="{padding: '24px 24px 24px'}">
          <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
            <router-view/>
          </Content>
          <Footer class="layout-footer-center">Copyright © 2018 东莞育诚信息科技有限公司 版权所有</Footer>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Index',
  
  data () {
    return {
    }
  },
  mounted(){
    
  },
  watch: {
    
  },
  methods:{
    test(){
      this.$http.postData(this, "/api/test", {}).then((resData)=> {}).catch((err)=>{})
    },
    logOut () {
      sessionStorage.removeItem("ewl_wms_token");
      this.$Message.info("退出登录");
      this.$router.push("/")
    }
  },
  created() {
  }
}
</script>
<style>
.index{
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.layout-logo{
  width: 100px;
  height: 30px;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 20px;
}
.layout-nav{
  width: 420px;
  margin: 0 auto;
  margin-right: 20px;
}

.ew-card .ivu-card-body {
  height: 90%;
}

</style>